import { jsx as _jsx } from "react/jsx-runtime";
import { TranslatableString } from '@rjsf/utils';
import { CommandBarButton } from '@fluentui/react';
const addIcon = { iconName: 'Add' };
export default function AddButton(props) {
    const { registry: { translateString }, } = props;
    return (_jsx(CommandBarButton, { style: { height: '32px' }, iconProps: addIcon, text: translateString(TranslatableString.AddItemButton), className: props.className, onClick: props.onClick, disabled: props.disabled }));
}
//# sourceMappingURL=AddButton.js.map